import { FC, ReactElement, useContext } from "react";
import { Select } from "antd";
import { useTranslation } from "react-i18next";
import { CellSelectWrap } from "@/pages/Sales/style";
import { DictContext } from "@/layout/context/DictContext";

interface SCreditLevelSelectProps {
  value?: string;
  onChange?: (value: string) => Promise<void>;
  readOnly?: boolean;
}

const PurchaseOrderTypeSelect: FC<SCreditLevelSelectProps> = ({
  value,
  onChange,
  readOnly = false,
}) => {
  const { t } = useTranslation();
  const { purchaseOrderTypes } = useContext(DictContext);

  const getEle: (readOnly: boolean) => ReactElement = (readOnly) => {
    return (
      <CellSelectWrap style={{ flex: 1 }}>
        <Select
          disabled={readOnly}
          value={value?.toString()}
          onChange={onChange}
          style={{ width: "100%" }}
          placeholder={t("purchase.plPurchaseType")}
          options={purchaseOrderTypes}
          fieldNames={{ label: "desc", value: "key" }}
          popupMatchSelectWidth={false}
        />
      </CellSelectWrap>
    );
  };

  return getEle(readOnly);
};

export default PurchaseOrderTypeSelect;
